import React, { useEffect } from "react";
import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutDefault from "../Shared/LayoutDefault";

import config from "./../../utils/const";
import "./style.scss";

const EducacaoPerfil = props => {
  useEffect(() => {
    props.actions.setProgressConfig(true, "40%", "2/5", "20%");
  }, [props.actions]);

  const HandleAction = val => {
    props.actions.setDonate("frequency", val);
  };

  return (
    <LayoutDefault
      className="wrapper-perfil"
      renderButtom={props => (
        <div className="wrapper-buttons">
          <Buttom
            to={`${config.url}educacao/amount/0`}
            text="Apoio único"
            onClick={() => {
              HandleAction("once");
            }}
            {...props}
          />
          <Buttom
            to={`${config.url}educacao/amount/1`}
            text="Apoio mensal"
            onClick={() => {
              HandleAction("monthly");
            }}
            {...props}
          />
        </div>
      )}
    >
      <Title className="title">
        Oferecemos algumas maneiras <br /> de apoiar em dinheiro.
      </Title>
      <p>
        Você também pode &nbsp;
        <a href="mailto:" target="_blank" rel="noopener noreferrer">
          entrar em contato
        </a>
        &nbsp;conosco <br className="d-none d-md-block" />
        para conhecer outras maneiras de nos apoiar.
      </p>
    </LayoutDefault>
  );
};

export default EducacaoPerfil;
